import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-y-hidden fill-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_progress_linear, {
      indeterminate: _ctx.appLoading,
      color: "primary"
    }, null, 8, ["indeterminate"]),
    _createVNode(_component_vue_pdf_embed, {
      class: "mt-n1",
      source: _ctx.privacyPdfUrl,
      ref: "pdf",
      width: _ctx.pageWidth,
      onRendered: _ctx.iframeLoaded
    }, null, 8, ["source", "width", "onRendered"])
  ]))
}